import { useContext, useEffect, useState } from "react";
import ExpertDataService from "../../services/Expert";
import {
  IconButton,
  Box,
  CloseButton,
  Flex,
  Icon,
  useColorModeValue,
  Text,
  Drawer,
  DrawerContent,
  useDisclosure,
  Input,
  BoxProps,
  FlexProps,
} from "@chakra-ui/react";
import { FaUserAlt } from "react-icons/fa";
import { IconType } from "react-icons";
import { ReactText } from "react";
import { appContext } from "../../Context/AppContext";

export default function Sidebar({ func }: any) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [data, setData] = useState<any>([]);
  const { chatId } = useContext(appContext);

  const [searchTerm, setSearchTerm] = useState('');

  const [searchFilteredData, setSearchFilteredData] = useState(data);

  const handleClicked = (id: string, isRead: any) => {
    const updatedData = data.map((el: any) => {
      return {
        user_name: el.user_name,
        userId: el.userId,
        isClicked: el.userId === id,
        isRead,
      };
    });
    setData(updatedData);
    if (window.innerWidth < 768) {
      onClose(); 
    }
  };

  const handleSearchByName = () => {
    if (searchTerm === '') {
      setSearchFilteredData(data);
    } else {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      const filtered = data.filter((item:any) =>
        // console.log(item.user_name);
      item.user_name && item.user_name.toLowerCase().includes(lowerCaseSearchTerm)
      );
      
      setSearchFilteredData(filtered);
    }
  };

  const fetchClientList = async () => {
    ExpertDataService.getClientList()
      .then((res) => {
        let data = [];
        if (chatId) {
          data = res.data.data.map((el: any) => {
            return {
              user_name: el.name,
              email:el.email,
              phone:el.phone,
              userId: el.userId,
              isClicked: el.userId === chatId,
              isRead: el.isRead,
            };
          });
        } else {
          data = res.data.data.map((el: any) => {
            return {
              email:el.email,
              phone:el.phone,
              user_name: el.name,
              userId: el.userId,
              isClicked: false,
              isRead: el.isRead,
            };
          });
        }
      setSearchFilteredData(data)
        setData(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    handleSearchByName();
  }, [searchTerm]);

  useEffect(() => {
    fetchClientList();
    setTimeout(() => {
      if (chatId) {
        handleClicked(chatId, true);
      }
    }, 1000);
  }, []);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };



  return (
    <Box
      mt={{ base: 0, md: 70 }}
      bg={useColorModeValue("green.100", "gray.900")}
      pt={{ base: 0, md: 5 }}
    >
      <IconButton
        display={{ base: "flex", md: "none" }}
        onClick={onOpen}
        icon={<FaUserAlt />}
        aria-label="Open menu"
      />
      <SidebarContent
        data={searchFilteredData}
        func={func}
        onClose={onClose}
        display={{ base: "none", md: "block" }}
        clickFunc={handleClicked}
        searchQuery={searchTerm}
        handleSearch={handleSearch}
      />
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full"
      >
        <DrawerContent>
          <SidebarContent
            data={searchFilteredData}
            clickFunc={handleClicked}
            func={func}
            onClose={onClose}
            searchQuery={searchTerm}
            handleSearch={handleSearch}
          />
        </DrawerContent>
      </Drawer>
    </Box>
  );
}

interface SidebarProps extends BoxProps {
  onClose: () => void;
  func: (id: any) => void;
  clickFunc: (id: any, isRead: any) => void;
  data: any[];
  searchQuery: string;
  handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SidebarContent = ({
  data,
  clickFunc,
  func,
  onClose,
  searchQuery,
  handleSearch,
  ...rest
}: SidebarProps) => {
  return (
    <Box
      bg={useColorModeValue("white", "gray.900")}
      borderRightColor={useColorModeValue("gray.200", "gray.700")}
      w={{ base: "full", md: 60 }}
      overflowY="scroll"
      pos="fixed"
      h={{ base: "calc(100vh - 65px)", md: "550px" }}
      {...rest}
    >
      <Box p="4">
        <Input
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearch}
          mb="4"
        />
      </Box>
      {data.length > 0 &&
        data.map((link: any) => (
          <NavItem
            key={link.userId}
            id={link.userId}
            isRead={link.isRead}
            func={func}
            icon={FaUserAlt}
            isClicked={link.isClicked}
            clickFunc={clickFunc}
          >
            <div>
              {link.user_name}
              <div className="small-text">
                {link.email}
              </div>
              <div className="small-text">
                {link.phone}
              </div>
            </div>
          </NavItem>
        ))}
    </Box>
  );
};

interface NavItemProps extends FlexProps {
  icon: IconType;
  children: React.ReactNode;
  func: (id: any) => void;
  id: string;
  isRead: any;
  clickFunc: (id: any, isRead: any) => void;
  isClicked: boolean;
}

const NavItem = ({
  icon,
  isClicked,
  clickFunc,
  func,
  id,
  isRead,
  children,
  ...rest
}: NavItemProps) => {
  const handleClick = () => {
    func(id);
    clickFunc(id, true);
  };

  return (
    <Box
      as="a"
      style={{ textDecoration: "none" }}
      _focus={{ boxShadow: "none" }}
      position="relative"
    >
      <Flex
        align="center"
        p="4"
        mx="4"
        borderRadius="lg"
        role="group"
        onClick={handleClick}
        cursor="pointer"
        _hover={{
          bg: "cyan.400",
          color: "white",
        }}
        bg={isClicked ? "green.400" : "transparent"}
        color={isClicked ? "white" : "inherit"}
        {...rest}
      >
        {icon && (
          <Icon
            mr="4"
            fontSize="16"
            _groupHover={{
              color: "white",
            }}
            as={icon}
          />
        )}
        {children}
        {isRead === false && (
          <Box
            position="absolute"
            top="40%"
            right="4"
            bg="red.500"
            w="12px"
            h="12px"
            borderRadius="50%"
          ></Box>
        )}
      </Flex>
    </Box>
  );
};
